import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subscription: null,
  plan: null,
  planLevel: 0,
  features: [],
  loading: false,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSubscription: (state, { payload }) => {
      state.subscription = payload;
      state.plan = payload?.plan || null;
      state.planLevel = payload?.planLevel || 0;
      state.features = payload?.features || [];
    },

    clearSubscription: (state) => {
      state.subscription = null;
      state.plan = null;
      state.planLevel = 0;
      state.features = [];
    },

    setSubscriptionLoading: (state, { payload }) => {
      state.loading = payload;
    },
  },
});

export const {
  setSubscription,
  clearSubscription,
  setSubscriptionLoading,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;